import React, { Component } from 'react';
import { Switch, Route, Link, HashRouter as Router } from 'react-router-dom'
import Gallery from '../gallery/Gallery'
import Home from '../home/Home'
import BussinesDevelopment from '../bussinesDevelopment/BussinesDevelopment'
import Rionegro from '../sites/Rionegro'
import Dosquebradas from '../sites/Dosquebradas'
import Header from '../header/Header'
import './App.css'


//import DesignApp from '../designApp/DesignApp'
import VisibleDesignApp from '../mosaic/visibleDesignApp'

/*const App = () => (
  <div>
    <VisibleDesignApp/>
  </div>
)*/







class App extends Component {
  constructor(props) {
    super(props)
    this.toggle = this.toggle.bind(this)
    this.state = { isOpen: false }
  }
  toggle() {
    this.setState({ isOpen: !this.state.isOpen })
  }
  render() {
    let tiles = 'tiles.json'
    return (
      <div>
        <Header></Header>
          <Switch>
            <Route key="0" exact={true} path="/" component={Home} />
            <Route key="1" exact={true} path="/galeria" component={Gallery} />
            <Route key="2" exact={true} path="/mosaicos" component={VisibleDesignApp} />
            <Route key="3" exact={true} path="/trayectoria" component={BussinesDevelopment} />
            <Route key="4" exact={true} path="/rionegro" component={Rionegro} />
            <Route key="5" exact={true} path="/dosquebradas" component={Dosquebradas} />
          </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/app/App.js